import { Injectable } from '@angular/core';
import { AppStateService } from '@services';
import { GlobalConfig, SegmentId } from '@types';
import { Logger } from '@utils/logger';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { GlobalConfigService } from './global-config-service';
import { SegmentService } from './segment.service';
import { StrategyConfiguration } from '../types/strategy-config.type';

const logger = Logger.getLogger('StrategyConfigService');

@Injectable({
  providedIn: 'root',
})
export class StrategyConfigService {
  private isPopulated$ = new BehaviorSubject<boolean>(false);

  public spaBaseUrl = '';
  public segmentId: SegmentId;
  public strategyConfigurations: StrategyConfiguration[];

  constructor(
    private segmentService: SegmentService,
    private globalConfigService: GlobalConfigService,
    private appStateService: AppStateService
  ) {
    combineLatest([
      this.globalConfigService.getGlobalConfigSubject$(),
      this.segmentService.getCurrentSegmentId$(),
    ]).subscribe(this.mapConfigData);
  }

  private mapConfigData = ([globalConfig, segmentId]: [
    GlobalConfig,
    SegmentId
  ]): void => {
    logger.debug('args', globalConfig, segmentId);

    if (!segmentId) {
      segmentId = this.segmentService.getDefaultSegmentId();
    }

    const strategyConfiguration = globalConfig.strategyConfiguration;

    if (!strategyConfiguration) {
      return;
    }

    this.strategyConfigurations = strategyConfiguration;
    this.segmentId = segmentId;
    this.spaBaseUrl = this.appStateService.getSpaBaseUrl();
    this.isPopulated$.next(true);
  };
}
